import { render, staticRenderFns } from "./ContactNumber.vue?vue&type=template&id=ca8c1ea4&scoped=true&"
import script from "./ContactNumber.vue?vue&type=script&lang=js&"
export * from "./ContactNumber.vue?vue&type=script&lang=js&"
import style0 from "./ContactNumber.vue?vue&type=style&index=0&id=ca8c1ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8c1ea4",
  null
  
)

export default component.exports